import { HStack } from '@chakra-ui/react';
import React from 'react';

import { TAccountTypeGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { IsolatedMultiSelect } from 'packages/common-frontend/components/MultiSelect';

type ExpensesFeesFilterMenuProps = {
  onChange: {
    accountTypes: React.Dispatch<
      React.SetStateAction<[] | TAccountTypeGQLType[]>
    >;
    countersigners: React.Dispatch<React.SetStateAction<[] | string[]>>;
  };
  options: {
    accountTypes: {
      label: string;
      value: TAccountTypeGQLType;
    }[];
    countersigners: { label: string; value: string }[];
  };
  selectedOptions: {
    accountTypes: TAccountTypeGQLType[] | [];
    countersigners: string[];
  };
};

export const ExpensesFeesFilterMenus = ({
  onChange,
  options,
  selectedOptions,
}: ExpensesFeesFilterMenuProps) => {
  if (!options || options.accountTypes.length === 0) {
    return null;
  }

  return (
    <HStack spacing="10px">
      <IsolatedMultiSelect
        options={options.accountTypes}
        onApplyOptions={(val) =>
          onChange.accountTypes(val as TAccountTypeGQLType[])
        }
        initialSelections={selectedOptions.accountTypes}
        titleText="Filter accounts"
        applyButtonText="Apply filters"
        optionsHeader="Account"
      />
      <IsolatedMultiSelect
        options={options.countersigners}
        onApplyOptions={(val) => onChange.countersigners(val)}
        initialSelections={selectedOptions.countersigners}
        titleText="Filter countersigners"
        applyButtonText="Apply filters"
        optionsHeader="Countersigner"
      />
    </HStack>
  );
};
